/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_EmailInputs */

const en_user_email = /** @type {(inputs: User_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const ja_user_email = /** @type {(inputs: User_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス`)
};

const fr_user_email = /** @type {(inputs: User_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const de_user_email = /** @type {(inputs: User_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {User_EmailInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_email = /** @type {((inputs?: User_EmailInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_EmailInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_email(inputs)
	if (locale === "ja") return ja_user_email(inputs)
	if (locale === "fr") return fr_user_email(inputs)
	return de_user_email(inputs)
});